import { returnValue } from 'common';
import typeActions from 'redux/typeActions';
const initialState = {
  partners: {},
  pagination: {},
  // form show/delete
  isModalVisible: false,
  modalInfo: {},
  page: 1,
  limit: 10,
  query: {
    populate: '*',
  },
};
const partnerReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case typeActions.SET_PARTNER_VALUE:
      const namePartner = actions.name;
      const valuePartner = actions.value;
      if (typeof namePartner !== 'string') return { ...state };
      const objPartner = returnValue(state, namePartner, valuePartner);
      return {
        ...state,
        ...objPartner,
      };
    case typeActions.GET_PARTNERS_REQUEST:
      return {
        ...state,
        ...actions?.data,
      };
    case typeActions.GET_PARTNERS_SUCCESS:
      return {
        ...state,
        partners: actions.data.results,
        pagination: actions.data.pagination,
        page: actions.data.pagination.page,
        limit: actions.data.pagination.pageSize,
      };
    case typeActions.GET_PARTNERS_FAILED:
      return {
        ...state,
      };
    // create

    case typeActions.CREATE_PARTNER_REQUEST:
      return {
        ...state,
        errors: {
          ...state.errors,
        },
      };
    case typeActions.CREATE_PARTNER_SUCCESS:
      return {
        ...state,
        errors: {
          ...state.errors,
          createAccount: '',
        },
      };
    case typeActions.CREATE_PARTNER_FAILED:
      return {
        ...state,
        errors: {
          ...state.errors,
          createAccount: actions.error,
        },
      };

    //delete
    case typeActions.DELETE_PARTNER_REQUEST:
      return {
        ...state,
      };
    case typeActions.DELETE_PARTNER_SUCCESS:
      return {
        ...state,
      };
    case typeActions.DELETE_PARTNER_FAILED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};

export default partnerReducer;
